import { CssBaseline, ThemeProvider } from '@mui/material'
import type { ReactNode } from 'react'
import { theme } from './theme'

export function MuiProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
